function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesListingCard from '@domain-group/fe-co-allhomes-listing-card';
import * as styles from './new-development-listings.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewDevelopmentListings = props => props.listings.length > 0 && ___EmotionJSX("div", null, props.listings.map(listing => ___EmotionJSX(AllhomesListingCard, _extends({
  css: styles.childCard,
  key: listing.id,
  displayType: "newdevelopments"
}, listing))));
NewDevelopmentListings.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes))
};
NewDevelopmentListings.defaultProps = {
  listings: []
};
export default NewDevelopmentListings;